import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=1ae57e05&scoped=true&"
import script from "./Home.vue?vue&type=script&lang=js&"
export * from "./Home.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae57e05",
  null
  
)

component.options.__file = "Home.vue"
export default component.exports